import { render, staticRenderFns } from "./bar_word_accuracy.vue?vue&type=template&id=80738aea&scoped=true&"
import script from "./bar_word_accuracy.vue?vue&type=script&lang=js&"
export * from "./bar_word_accuracy.vue?vue&type=script&lang=js&"
import style0 from "./bar_word_accuracy.vue?vue&type=style&index=0&id=80738aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80738aea",
  null
  
)

export default component.exports